import script from "./OCR_page.vue?vue&type=script&setup=true&lang=js"
export * from "./OCR_page.vue?vue&type=script&setup=true&lang=js"

import "./OCR_page.vue?vue&type=style&index=0&id=63ca6456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ca6456"]])

export default __exports__